import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { CreateUserForm } from '~/features/CreateUserForm';
import styles from './index.module.scss';

/**
 * 利用者追加画面 Screen（新パターン）
 */
export const Screen: React.FC = () => {
  return (
    <>
      <PageHeader
        breadcrumbItems={[{ label: '利用者一覧', href: '/users' }, { label: '新規追加' }]}
      />
      <main className={styles.body}>
        <Suspense fallback={<Loader />}>
          <CreateUserForm />
        </Suspense>
      </main>
    </>
  );
};
